import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Pill, Dumbbell, BedDouble } from 'lucide-react';
export function FailedSolutions() {
  const solutions = [{
    icon: <Pill className="w-10 h-10 text-stone-400" data-id="element-2" />,
    text: 'Los analgésicos solo apagan la alarma del incendio, pero dejan que el fuego siga quemando tus articulaciones por dentro.'
  }, {
    icon: <Dumbbell className="w-10 h-10 text-stone-400" data-id="element-3" />,
    text: 'Los estiramientos de gimnasio son demasiado agresivos para un cuerpo frío y terminan causando micro-desgarros.'
  }, {
    icon: <BedDouble className="w-10 h-10 text-stone-400" data-id="element-4" />,
    text: 'El reposo excesivo es el peor enemigo, porque la articulación que no se mueve, se calcifica y se bloquea para siempre.'
  }];
  return <section className="bg-[#FDF6EE] text-stone-800 py-24 px-4" data-id="element-5">
      <div className="max-w-5xl mx-auto" data-id="element-6">
        <FadeIn data-id="element-7">
          <h2 className="text-3xl md:text-4xl font-black mb-16 text-center text-stone-900" data-id="element-8">
            Por qué lo que has intentado no funciona
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-9">
            {solutions.map((solution, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-10">
                <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-200 h-full flex flex-col items-center text-center" data-id="element-11">
                  <div className="bg-stone-100 p-4 rounded-full mb-6" data-id="element-12">
                    {solution.icon}
                  </div>
                  <p className="text-lg md:text-xl text-stone-600 leading-relaxed" data-id="element-13">
                    {solution.text}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}